
// ============================================
// SceneController - シーン管理システム
// ============================================
/**
 * GNS.SceneController
 * 
 * !!!!! アプリケーション全体の中枢 !!!!!
 * 
 * 責務:
 * 1. ページ初期化とシーン管理
 * 2. ページ遷移（Single Page Application対応）
 * 3. Cookie確認
 * 
 * 主要メソッド:
 * - init(): アプリケーション初期化
 * - sceneInitialize(): 現在のページに対応するシーンを作成
 * - gotoSceneAt(url): ページ遷移
 * - cookieCheck(): Cookie同意確認
 * 
 * プロパティ:
 * - isSinglePageApp: SPA対応フラグ
 * - activePage: 現在のシーン
 * - nextPage: 次のシーン
 * - dispatcher: イベントディスパッチャー
 */
GNS.SceneController = function (GNS) {
    var controller = GNS.create();
    controller._static.dispatcher = new GNS.EventDispatcher;
    controller._static.isSinglePageApp = !1;
    controller._static.activePage = null;
    controller._static.nextPage = null;

    /**
     * init() - SceneController初期化
     */
    controller._static.init = function () {
        GNS.Logger.log("SceneController :: init");
        GNS.Wrapper.getInstance();
        GNS.Header.getInstance();
        GNS.Footer.getInstance();
        GNS.Contents.getInstance();
        GNS.PageLoading.getInstance();
        GNS.SiteLoading.getInstance();
        GNS.ResizeManager.init();

        if (window.history && window.history.pushState) {
            controller._static.isSinglePageApp = !0;
        }

        if (GNS.Globals.jsSP && GNS.isAndroid) {
            GNS.Document.getInstance().body.addClass("type-android");
        }
        if (GNS.Globals.jsSP && GNS.isIOS) {
            GNS.Document.getInstance().body.addClass("type-ios");
        }

        GNS.Animate.to(document, .01, {
            scrollTop: 0
        });

        startLoading();
    };

    var startLoading = function () {
        GNS.Logger.log("SceneController :: startLoading");
        var mode = window.DOFInitialLoadingMode || "site";
        if ("page" === mode) {
            window.DOFInitialLoadingMode = void 0;
            GNS.PageLoading.getInstance().show();
            loadComplete();
        } else {
            window.DOFInitialLoadingMode = void 0;
            GNS.PageLoading.getInstance().hide();
            GNS.SiteLoading.getInstance().show(function () {
                loadComplete();
            });
        }
    };

    var loadComplete = function (c) {
        GNS.Logger.log("SceneController :: loadComplete");
        controller._static.cookieCheck();
        controller._static.scrollPopup = new GNS.DisplayObject("scroll_popup");
        controller._static.sceneInitialize();
    };

    controller._static.cookieCheck = function () {
        if (null == GNS.CookieManager.getKey("cookieAccepted")) {
            var cookiePopup = new GNS.DisplayObject("cookie_popup");
            GNS.AbstractScene.addSceneEventIn(cookiePopup.element);
            cookiePopup.btn = new GNS.DisplayObject("cookie_popup__close");
            cookiePopup.btn.addEvent("click", function (c) {
                cookiePopup.removeClass("show");
                GNS.CookieManager.setKey("cookieAccepted", 1);
            });
            TweenMax.set(cookiePopup.element, {
                alpha: 1,
                y: "100%"
            });
            cookiePopup.addClass("show");
            TweenMax.to(cookiePopup.element, .7, {
                alpha: 1,
                y: "0%",
                ease: Quart.easeOut
            });
        }
    };

    var isSceneTransitioning = !0;

    /**
     * sceneInitialize() - シーン初期化
     */
    controller._static.sceneInitialize = function () {
        var contentsNodes = GNS.Contents.getInstance().element.childNodes;
        var pageElement = null;
        var pageId = null;

        for (var f = 0; f < contentsNodes.length; f++) {
            if (-1 != String(contentsNodes[f].className).indexOf("page")) {
                pageElement = contentsNodes[f];
                pageId = pageElement.id;
                break;
            }
        }

        if (pageElement && pageId) {
            var menuIndex = -1;
            switch (pageId) {
                case "index":
                    controller._static.activePage = new GNS.IndexScene(pageElement);
                    menuIndex = 0;
                    break;
                case "ourbusiness":
                    controller._static.activePage = new GNS.OurBusinessScene(pageElement);
                    menuIndex = 3;
                    break;
                case "contact":
                    controller._static.activePage = new GNS.ContactScene(pageElement);
                    menuIndex = 6;
                    break;
                case "recruit":
                    controller._static.activePage = new GNS.RecruitScene(pageElement);
                    menuIndex = 5;
                    break;
                case "who_we_are_detail":
                    controller._static.activePage = new GNS.WhoWeAreDetailScene(pageElement);
                    menuIndex = 1;
                    break;
                case "member_detail":
                    controller._static.activePage = new GNS.MemberDetailScene(pageElement);
                    menuIndex = 2;
                    break;
                case "who_we_are":
                    controller._static.activePage = new GNS.WhoWeAreScene(pageElement);
                    menuIndex = 1;
                    break;
                case "member":
                    controller._static.activePage = new GNS.MemberScene(pageElement);
                    menuIndex = 2;
                    break;
                case "news":
                    controller._static.activePage = new GNS.NewsScene(pageElement);
                    menuIndex = 4;
                    break;
                case "newsdetail":
                    controller._static.activePage = new GNS.NewsDetailScene(pageElement);
                    menuIndex = 4;
                    break;
                case "casesdetail":
                    controller._static.activePage = new GNS.CasesDetailScene(pageElement);
                    menuIndex = 3;
                    break;
                case "cases":
                    controller._static.activePage = new GNS.CasesScene(pageElement);
                    menuIndex = 3;
                    break;
                case "talkdetail":
                    controller._static.activePage = new GNS.TalkDetailScene(pageElement);
                    menuIndex = 7;
                    break;
                case "talk":
                    controller._static.activePage = new GNS.TalkScene(pageElement);
                    menuIndex = 7;
                    break;
                case "cookiepolicy":
                    controller._static.activePage = new GNS.CookiePolicyScene(pageElement);
                    menuIndex = 0;
            }

            if (menuIndex >= 0) {
                GNS.Menu.getInstance().setActive(menuIndex);
            }

            if ("index" == pageId) {
                GNS.Header.getInstance().autoShow();
            } else {
                GNS.Header.getInstance().alwaysShow();
            }

            if (controller._static.scrollPopup) {
                controller._static.scrollPopup.removeClass("show");
            }

            controller._static.activePage.addEventListener(GNS.Event.LOAD, controller._static.sceneTransitionLoaded);
            controller._static.activePage.load();
        }
    };

    controller._static.sceneTransitionLoaded = function () {
        controller._static.activePage.removeEventListener(GNS.Event.LOAD, controller._static.sceneTransitionLoaded);

        // Cloudflareのメールリンク保護を解除・復元
        if (controller._static.fixCloudflareEmails) {
            controller._static.fixCloudflareEmails();
        }

        // casesページの場合のフィルタリング処理
        var isCasesPage = controller._static.activePage && controller._static.activePage.element && controller._static.activePage.element.id === 'cases';
        if (isCasesPage) {
            var attempts = 0;
            var maxAttempts = 20;
            function tryInitAfterTransition() {
                attempts++;
                if (typeof window.initCasesFilter === 'function') {
                    setTimeout(function () {
                        window.initCasesFilter();
                    }, 200);
                } else if (attempts < maxAttempts && controller._static.activePage && controller._static.activePage._initializeFiltering) {
                    setTimeout(function () {
                        controller._static.activePage._initializeFiltering();
                    }, 200);
                } else if (attempts < maxAttempts) {
                    setTimeout(tryInitAfterTransition, 100);
                }
            }
            setTimeout(tryInitAfterTransition, 300);
        }

        var ensureWrapperReleased = function () {
            try {
                var wrapper = GNS.Wrapper.getInstance();
                wrapper.setFixed(!1);
                if (wrapper.restoreScroll) wrapper.restoreScroll();
            } catch (e) { }
            try {
                GNS.Animate.direct(document, {
                    scrollTop: 0
                });
            } catch (e1) { }
            try {
                if (window.scrollTo) window.scrollTo(0, 0);
            } catch (e2) { }
        };

        if (isSceneTransitioning) {
            GNS.DOM.addEvent(window, "popstate", controller._static.onPopState);
            GNS.SiteLoading.getInstance().hide(function () {
                GNS.Document.getInstance().body.addClass("loaded");
                ensureWrapperReleased();
                controller._static.activePage.show();
            });
            isSceneTransitioning = !1;
        } else {
            ensureWrapperReleased();
            controller._static.activePage.show();
        }
    };

    controller._static.onPopState = function (e) {
        if (!e.originalEvent || e.originalEvent.state) {
            controller._static.sceneLoadAt(location.href, !0);
        }
    };

    controller._static.gotoSceneAt = function (url) {
        if (url != window.location.href) {
            controller._static.sceneLoadAt(url);
        }
    };

    var pendingUrl, isPopState;

    controller._static.sceneLoadAt = function (url, _isPopState) {
        if (url) {
            GNS.Logger.log("SceneController :: sceneLoadAt -> " + url);

            if (!controller._static.isSinglePageApp) {
                location.href = url;
                return;
            }

            try {
                var targetUrl = new URL(url, window.location.href);
                if (targetUrl && Array.isArray(window.DOFSpaDisablePaths)) {
                    var normalizedTargetPath = targetUrl.pathname.replace(/\/+$/, "");
                    var shouldDisableSpa = window.DOFSpaDisablePaths.some(function (entry) {
                        if (!entry) return !1;
                        var entryStr = String(entry);
                        if (entryStr.indexOf('prefix:') === 0) {
                            var prefixPath = entryStr.slice(7).replace(/\/+$/, "");
                            if (!prefixPath) return !1;
                            if (normalizedTargetPath === prefixPath) return !0;
                            return normalizedTargetPath.indexOf(prefixPath + '/') === 0;
                        }
                        var normalizedEntry = entryStr.replace(/\/+$/, "");
                        return normalizedEntry === normalizedTargetPath;
                    });

                    if (shouldDisableSpa) {
                        try { window.DOFInitialLoadingMode = 'site'; } catch (ex) { }
                        try { GNS.PageLoading.getInstance().hide(); } catch (e1) { }
                        try { GNS.SiteLoading.getInstance().hide(function () { }); } catch (e2) { }
                        try {
                            var wrapper = GNS.Wrapper.getInstance();
                            wrapper.setFixed(!1);
                            if (wrapper.restoreScroll) wrapper.restoreScroll();
                        } catch (e3) { }
                        try { GNS.Animate.direct(document, { scrollTop: 0 }); } catch (e4) { }
                        try { if (window.scrollTo) window.scrollTo(0, 0); } catch (e5) { }
                        window.location.href = url;
                        return;
                    }
                }
            } catch (err) {
                console.warn('SceneController: URL parsing failed', err);
                try { window.DOFInitialLoadingMode = 'site'; } catch (ex2) { }
                window.location.href = url;
                return;
            }

            try { window.DOFInitialLoadingMode = 'page'; } catch (ex3) { }

            pendingUrl = url;
            isPopState = _isPopState ? !1 : !0;

            if (controller._static.activePage) {
                controller._static.activePage.removeEventListener(GNS.Event.COMPLETE, controller._static.sceneTransitionHide);
                controller._static.activePage.addEventListener(GNS.Event.COMPLETE, controller._static.sceneTransitionHide);
                controller._static.activePage.hide();
            } else {
                controller._static.sceneTransitionHide();
            }
        }
    };

    var loader;

    controller._static.sceneTransitionHide = function () {
        if (controller._static.activePage) {
            controller._static.activePage.removeEventListener(GNS.Event.COMPLETE, controller._static.sceneTransitionHide);
            controller._static.activePage.reset();
            GNS.Contents.getInstance().element.removeChild(controller._static.activePage.element);
            controller._static.activePage = null;
        }

        GNS.Animate.to(document, .01, {
            scrollTop: 0
        });

        GNS.PageLoading.getInstance().show();

        if (loader) {
            loader.cancel();
        } else {
            loader = new GNS.Loader;
            loader.addEventListener(GNS.LoadEvent.SUCCESS, onLoaderSuccess);
            loader.addEventListener(GNS.LoadEvent.FAILED, onLoaderSuccess); // FailでもSuccessと同じ扱いにしてハンドリング
            loader.addEventListener(GNS.LoadEvent.CANCEL, onLoaderSuccess);
        }
        loader.load("text/html", pendingUrl, null, "GET");
    };

    var onLoaderSuccess = function (e) {
        if (e.type === GNS.LoadEvent.CANCEL) {
            return;
        }
        var contentText = null;
        if (e.type !== GNS.LoadEvent.FAILED && e.params && e.params.content) {
            contentText = e.params.content.responseText;
        } else if (e.params && e.params.target && e.params.target.service) {
            contentText = e.params.target.service.responseText;
        }

        if (contentText && contentText.length) {
            if (!injectContent(contentText)) {
                fallbackToNormalTransition();
            }
        } else {
            fallbackToNormalTransition();
        }
    };

    var parseHtmlDocument = function (html) {
        try {
            if (window.DOMParser) {
                return new window.DOMParser().parseFromString(html, "text/html");
            }
        } catch (error) {
            console.warn("SPA Transition: HTML parsing failed", error);
        }

        var fallbackDocument = document.implementation.createHTMLDocument("");
        fallbackDocument.documentElement.innerHTML = html;
        return fallbackDocument;
    };

    controller._static.syncAioHead = function (sourceDocument) {
        if (!sourceDocument || !sourceDocument.head || !document.head) {
            return 0;
        }

        var selector = "[data-dof-aio]";
        var sourceNodes = sourceDocument.head.querySelectorAll(selector);
        if (!sourceNodes.length) {
            return 0;
        }

        var replacementNodes = [];
        for (var sourceIndex = 0; sourceIndex < sourceNodes.length; sourceIndex++) {
            replacementNodes.push(document.importNode ?
                document.importNode(sourceNodes[sourceIndex], true) :
                sourceNodes[sourceIndex].cloneNode(true));
        }

        var currentNodes = document.head.querySelectorAll(selector);
        var insertionPoint = currentNodes.length ? currentNodes[0] : null;
        for (var replacementIndex = 0; replacementIndex < replacementNodes.length; replacementIndex++) {
            document.head.insertBefore(replacementNodes[replacementIndex], insertionPoint);
        }
        for (var currentIndex = currentNodes.length - 1; currentIndex >= 0; currentIndex--) {
            if (currentNodes[currentIndex].parentNode) {
                currentNodes[currentIndex].parentNode.removeChild(currentNodes[currentIndex]);
            }
        }

        return replacementNodes.length;
    };

    var isExecutableScript = function (script) {
        if (!script || script.hasAttribute("data-dof-aio")) {
            return !1;
        }

        var scriptType = (script.getAttribute("type") || "").toLowerCase().replace(/^\s+|\s+$/g, "");
        return !scriptType ||
            scriptType === "text/javascript" ||
            scriptType === "application/javascript" ||
            scriptType === "text/ecmascript" ||
            scriptType === "application/ecmascript";
    };

    var injectContent = function (html) {
        var sourceDocument = parseHtmlDocument(html);
        var newContent = sourceDocument.querySelector("#contents .page");
        if (!newContent) {
            return !1;
        }

        var titleElement = sourceDocument.querySelector("title[data-dof-aio], title");
        if (titleElement && isPopState) {
            history.pushState(null, titleElement.textContent || "", pendingUrl);
        }

        var syncedHeadCount = controller._static.syncAioHead(sourceDocument);
        if (!syncedHeadCount && titleElement) {
            document.title = titleElement.textContent || "";
        }

        // 追加される要素内の<script>タグを抽出して実行する
        var scriptsToExecute = [];
        var scripts = sourceDocument.querySelectorAll("script");
        for (var si = 0; si < scripts.length; si++) {
            var script = scripts[si];
            if (!isExecutableScript(script)) {
                continue;
            }
            if (script.src) {
                // 外部スクリプトの場合は新しくscript要素を作成して読み込む
                var newScript = document.createElement("script");
                newScript.src = script.src;
                newScript.async = script.async || false;
                document.body.appendChild(newScript);
            } else if (script.innerHTML || script.textContent) {
                // インラインスクリプトは保存して後で実行
                var scriptContent = script.innerHTML || script.textContent;
                scriptsToExecute.push(scriptContent);
            }
        }

        GNS.Contents.getInstance().element.appendChild(newContent);

        // インラインスクリプトを実行
        for (var sj = 0; sj < scriptsToExecute.length; sj++) {
            try {
                // グローバルスコープで実行
                var scriptCode = scriptsToExecute[sj];
                (new Function(scriptCode))();
            } catch (err) {
                console.error('SPA Transition: Script execution error:', err);
            }
        }

        controller._static.sceneInitialize();
        return !0;
    };

    controller._static.fixCloudflareEmails = function () {
        try {
            var links = document.querySelectorAll('a[href^="/cdn-cgi/l/email-protection#"]');
            for (var i = 0; i < links.length; i++) {
                var link = links[i];
                var encoded = link.href.split('/cdn-cgi/l/email-protection#')[1];
                if (encoded) {
                    var email = "";
                    var r = parseInt(encoded.substr(0, 2), 16);
                    for (var n = 2; n < encoded.length; n += 2) {
                        var c = parseInt(encoded.substr(n, 2), 16) ^ r;
                        email += String.fromCharCode(c);
                    }
                    link.href = "mailto:" + email;
                }
            }
        } catch (e) {
            console.warn("Cloudflare email fix failed", e);
        }
    };

    var fallbackToNormalTransition = function () {
        try { window.DOFInitialLoadingMode = "site"; } catch (e) { }
        try { GNS.PageLoading.getInstance().hide(); } catch (e1) { }
        try { GNS.SiteLoading.getInstance().hide(function () { }); } catch (e2) { }
        try {
            var wrapper = GNS.Wrapper.getInstance();
            wrapper.setFixed(!1);
            if (wrapper.restoreScroll) wrapper.restoreScroll();
        } catch (e3) { }
        try { GNS.Animate.direct(document, { scrollTop: 0 }); } catch (e4) { }
        try { if (window.scrollTo) window.scrollTo(0, 0); } catch (e5) { }
        window.location.href = pendingUrl;
    };

    return controller._self;
}(GNS);
